/// <amd-module name="TFS/Admin/Groups/Pivots/MemberOf/Components/MemberOfPivot" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";

import { DynamicModuleLoader } from "redux-dynamic-modules";
import { getMemberOfPivotModule } from "TFS/Admin/Groups/Pivots/MemberOf/Redux/MemberOfPivotModule";
import { ConnectedMemberOfPivotInitializer } from "TFS/Admin/Groups/Pivots/MemberOf/Components/MemberOfPivotInitializer";

export interface IMemberOfPivotProps extends IPivotProps {}

export class MemberOfPivot extends VssComponent<IMemberOfPivotProps> {
    constructor(props: IMemberOfPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <DynamicModuleLoader modules={[getMemberOfPivotModule()]}>
                <ConnectedMemberOfPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />
            </DynamicModuleLoader>
        );
    }
}

VssComponent.register("ms.vss-admin-web.groups-memberof-pivot", MemberOfPivot);
